<!-- style.height=auto -> To make sure that for long text the height of the link would increase -->
<div class="flex items-center">
    <a
        mat-list-item
        class="sidenav-link"
        [style.height]="'auto'"
        [style.paddingLeft]="paddingLeftTotal + 'px'"
        [routerLink]="routerLink"
        routerLinkActive="sidenav-link--active"
        ariaCurrentWhenActive="page">
        <div class="nav-link-text flex items-center justify-start my-3">
            @if (iconName) {
                <mat-icon class="shrink-0">
                    {{ iconName }}
                </mat-icon>
            }
            <!-- Make sure the long text would be broken to not overflow the span
            min-w-0: -> It is a flex item -> manually override min-w to make the word break possible
            whitespace-normal -> default set to 'nowrap' from Angular Material - here, we override it
            break-words -> Breaking the words -->
            <span class="ms-4 min-w-0 whitespace-normal break-words">
                {{ navLinkText }}
            </span>
        </div>
    </a>
    <div class="selected-marker"></div>
</div>
